import { render, staticRenderFns } from "./DetailViewPlant.vue?vue&type=template&id=1a1c54b8&scoped=true&"
import script from "./DetailViewPlant.vue?vue&type=script&lang=js&"
export * from "./DetailViewPlant.vue?vue&type=script&lang=js&"
import style0 from "./DetailViewPlant.vue?vue&type=style&index=0&id=1a1c54b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c54b8",
  null
  
)

export default component.exports